import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-base pt-16 px-2 flex flex-col w-full 2xl:w-[50%] mx-auto" }
const _hoisted_2 = { class: "flex gap-6 items-center pb-4" }
const _hoisted_3 = { class: "text-gray-900 font-medium text-lg" }
const _hoisted_4 = { class: "flex items-center flex-col" }
const _hoisted_5 = { class: "my-1 font-semibold text-base" }
const _hoisted_6 = { class: "flex-row mb-4 pt-2 bg-white rounded-[1.25rem] flex items-start justify-between" }
const _hoisted_7 = { class: "flex w-full justify-evenly" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col p-6 justify-start border border-blue-300 rounded-xl"
}
const _hoisted_9 = { class: "font-semibold text-sm text-gray-700" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "shadow-classes border border-blue-300 rounded-lg p-2 px-4 mr-2 text-gray-700 text-sm font-semibold" }
const _hoisted_12 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_13 = {
  value: "",
  disabled: ""
}
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col p-6 justify-start border border-blue-300 rounded-xl"
}
const _hoisted_16 = { class: "font-semibold text-sm" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "shadow-classes border border-gray-300 rounded-lg p-2 px-4 mr-2 text-gray-700 text-sm font-semibold" }
const _hoisted_19 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_20 = {
  value: "",
  disabled: ""
}
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "flex justify-end mt-8"
}
const _hoisted_23 = { class: "font-semibold text-sm" }

import { onBeforeMount, ref } from 'vue';
import { NewClassTeacher } from '@/interfaces/school-structure.interface';
import { defaultGrades } from "@/modules/main/components/constants/defaults";

type SelectedGradesType = ReturnType<typeof defaultGrades>;


export default /*#__PURE__*/_defineComponent({
  __name: 'AssignNewTeachersToClasses',
  props: {
    grades: {},
    teacherList: {}
  },
  emits: ["handleBack", "handleNext"],
  setup(__props: any, { emit }) {

const props = __props;





const selectedGrades = ref(defaultGrades());
const teachers = ref<NewClassTeacher[]>([]);

onBeforeMount(() => {
    selectedGrades.value = props.grades;
    teachers.value = props.teacherList;
});

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "flex gap-6 items-center pb-4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('handleBack')))
      }, [
        _createVNode(_component_rl_icon, {
          icon: 'rl-back-arrow',
          title: 'rl back arrow',
          "aria-hidden": "true"
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.assign_teacher")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGrades.value.filter((x) => x.selected), (grade, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "w-full",
          key: index
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.grade")) + " " + _toDisplayString(grade.grade), 1),
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (grade.classes.some((c) => c.english == true))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.english")), 1),
                    _createElementVNode("p", {
                      class: "py-3 font-normal text-sm text-gray-600",
                      innerHTML: _ctx.$t('add_grades_class_component.step_3.subject')
                    }, null, 8, _hoisted_10),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.classes.filter((c) => c.english == true), (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex items-center justify-center mb-3",
                        key: c.tempId
                      }, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(c.name.toUpperCase()), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "teachers",
                          class: "border border-gray-300 mr-10 w-40 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5",
                          placeholder: _ctx.$t('add_grades_class_component.step_3.select_teacher')
                    ,
                          "onUpdate:modelValue": ($event: any) => ((c.englishTeachers) = $event)
                        }, [
                          _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.select_teacher")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: teacher,
                              key: teacher.tempId
                            }, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 9, _hoisted_14))
                          }), 128))
                        ], 8, _hoisted_12), [
                          [_vModelSelect, c.englishTeachers]
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (grade.classes.some((c) => c.maths == true))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.maths")), 1),
                    _createElementVNode("p", {
                      class: "py-3 font-normal text-sm text-gray-600",
                      innerHTML: _ctx.$t('add_grades_class_component.step_3.subject')
                    }, null, 8, _hoisted_17),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grade.classes.filter((c) => c.maths == true), (c) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex items-center justify-center mb-3",
                        key: c.tempId
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(c.name.toUpperCase()), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "teachers",
                          class: "border border-gray-300 mr-10 w-40 text-gray-600 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5",
                          placeholder: _ctx.$t('add_grades_class_component.step_3.select_teacher')
                    ,
                          "onUpdate:modelValue": ($event: any) => ((c.mathsTeachers) = $event)
                        }, [
                          _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.select_teacher")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: teacher,
                              key: teacher.tempId
                            }, _toDisplayString(teacher.firstName) + " " + _toDisplayString(teacher.lastName), 9, _hoisted_21))
                          }), 128))
                        ], 8, _hoisted_19), [
                          [_vModelSelect, c.mathsTeachers]
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (index === selectedGrades.value.filter((x) => x.selected).length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("button", {
                  class: "px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('handleNext')))
                }, [
                  _createElementVNode("h1", _hoisted_23, _toDisplayString(_ctx.$t("add_grades_class_component.step_3.btn_review")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})